/* src/app/components/controls/content-controls/sem-last-edited-data/sem-last-edited-data.component.css */
/*# sourceMappingURL=sem-last-edited-data.component.css.map */
